import React from 'react';
import './Careers.css';

const openRoles = [
  {
    title: 'Frontend Developer',
    type: 'Full-time · Remote',
    description: 'Build thoughtful, responsive experiences with React and modern web technologies.',
  },
  {
    title: 'QA Automation Engineer',
    type: 'Full-time · Remote',
    description: 'Help teams ship reliable software through practical testing and automation.',
  },
  {
    title: 'Digital Marketing Specialist',
    type: 'Full-time · Remote',
    description: 'Create digital strategies that help ambitious businesses reach the right audience.',
  },
];

const Careers = () => {
  return (
    <main className="careers-page">
      <section className="careers-intro">
        <span className="careers-eyebrow">Join SnowTechLabs</span>
        <h1>Build what matters with us.</h1>
        <p>
          We are a growing technology team creating useful digital products for businesses around the world.
        </p>
      </section>

      <section className="careers-roles" aria-labelledby="open-roles-title">
        <div className="careers-section-heading">
          <span className="careers-kicker">Open opportunities</span>
          <h2 id="open-roles-title">Find your next role</h2>
        </div>

        <div className="careers-role-list">
          {openRoles.map((role) => (
            <article className="careers-role" key={role.title}>
              <div>
                <h3>{role.title}</h3>
                <span className="careers-role-type">{role.type}</span>
                <p>{role.description}</p>
              </div>
              <a href="mailto:info@snowtechlabs.com?subject=Careers%20at%20SnowTechLabs">
                Apply <span aria-hidden="true">-&gt;</span>
              </a>
            </article>
          ))}
        </div>
      </section>

      <section className="careers-contact">
        <h2>Do not see your role?</h2>
        <p>Send us your resume. We are always happy to meet talented people.</p>
        <a className="careers-contact-link" href="mailto:info@snowtechlabs.com?subject=General%20Careers%20Inquiry">
          Email our team <span aria-hidden="true">-&gt;</span>
        </a>
      </section>
    </main>
  );
};

export default Careers;
